import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { lastValueFrom } from 'rxjs';
import { DialogConfirmationComponent } from 'src/app/includes/census-patient-list/dialog-confirmation/dialog-confirmation.component';
import { CommonService } from 'src/app/services/common.service';
import { CreateWoundDialogComponent } from '../create-wound-dialog/create-wound-dialog.component';
import { SetWoundStageDialogComponent } from '../set-wound-stage-dialog/set-wound-stage-dialog.component';
import { WoundCareWidgetService } from '../wound-care-widget.service';
import { WoundImagePreviewDialogComponent } from '../wound-image-preview-dialog/wound-image-preview-dialog.component';
import { WoundImageSnapshotDialogComponent } from '../wound-image-snapshot-dialog/wound-image-snapshot-dialog.component';
import { WoundImageUploadDialogComponent } from '../wound-image-upload-dialog/wound-image-upload-dialog.component';
import { WoundNoteDialogComponent } from '../wound-note-dialog/wound-note-dialog.component';
import { calculateTimeDifference, calculateArea, calculateVolume, calculateAreaforBanner, calculateVolumeforBanner } from '../wound-utils'
@Component({
  selector: 'app-wound-care-widget-item',
  templateUrl: './wound-care-widget-item.component.html',
  styleUrls: ['./wound-care-widget-item.component.css']
})
export class WoundCareWidgetItemComponent implements OnInit {
  childWoundsLoaderId = 'childWoundsLoaderId' + Math.random();
  randomValue = [1 + Math.random() * 10, 1 + Math.random() * 10]
  @Input() provider;
  @Input() readOnlyMode: any;
  @Input() patient;
  @Input() wound;
  @Input() isPreview;
  @Input() note;
  @Output() changeWoundState = new EventEmitter<any>();
  @Output() onICDsSave = new EventEmitter<any>();
  @Output() woundAnalyticReport = new EventEmitter<any>();
  @Output() woundDetailsChange = new EventEmitter<any>();
  // [expanded]="step === 0" (opened)="setStep(0)"
  expanded = false;
  showAllImages = false;
  last_n_weeks: string = 'all';

  expandedView: 'child_wounds' | 'graph' | 'wound_images' | '' = '';
  actualArea: any;
  actualVolume: any;
  negativeArea: any;
  negativeVolume: any;
  mainImage: string;
  otherImages: string[] = [];
  actualParentWound: any;
  previous_state: any;
  time_difference: any;
  percentageArea: number;
  percentageVolume: number;
  constructor(
    private _toaster: ToastrService,
    private loader: NgxUiLoaderService,
    private dialog: MatDialog,
    private woundCareWidgetService: WoundCareWidgetService,
    private commonService: CommonService
  ) { }

  async ngOnInit(): Promise<void> {
    if (this.wound) {
      if (!this.wound.parent_wound) {
        this.actualParentWound = this.wound;
        this.actualParentWound._most_recent_wound = true;
      } else {
        this.actualParentWound = this.wound.latest_child_wound.find(wound => !wound.parent_wound);
        this.wound._most_recent_wound = true;
      }
      this.previous_state = this.actualParentWound.state;
      this.mainImage = this.wound.wound_images[0];
      await this.initChildWounds();
      if (this.wound.wound_images.length > 1) {
        this.otherImages = this.wound.wound_images.slice(1)
      }
    }
  }

  async initChildWounds() {
    this.loader.startLoader(this.childWoundsLoaderId);
    const lastNWeeks = this.last_n_weeks === 'all' ? undefined : parseInt(this.last_n_weeks);
    let dateFrom, dateTo;
    if (lastNWeeks) {
      dateFrom = moment().startOf('day').subtract(lastNWeeks, 'weeks').toDate(); // last x week
      dateTo = moment().endOf('day').toDate(); // today
      this.time_difference = lastNWeeks == 1 ? lastNWeeks + " week" : lastNWeeks + " weeks";
    } else {
      this.time_difference = this.calculateTimeDifference(this.wound);
    }
    const { status, data } = await lastValueFrom(this.woundCareWidgetService.getChildWounds(
      this.actualParentWound.patient_id,
      this.actualParentWound._id,
      dateFrom, dateTo
    ));
    if (status == 200) {
      // const {child_wounds, ...wound} = this.wound;
      for (const child_wound of data) {
        if (this.wound._id === child_wound._id) {
          this.wound = child_wound;
          break;
        }
      }
      this.wound.child_wounds = data;

    } else {
      this.wound.child_wounds = []
    }
    if (this.wound?.child_wounds?.length > 0) {
      this.wound.child_wounds[0]._most_recent_wound = true;
      if (this.last_n_weeks === 'all' || this.isWoundInDateRange(this.actualParentWound)) {
        this.percentageArea = ((calculateArea(this.wound?.child_wounds[0]) - calculateArea(this.actualParentWound))/calculateArea(this.actualParentWound))*100;
        this.percentageVolume = ((calculateVolume(this.wound?.child_wounds[0]) - calculateVolume(this.actualParentWound))/calculateVolume(this.actualParentWound))*100;
        // this.actualArea = ((calculateArea(this.wound?.child_wounds[0]) - calculateArea(this.actualParentWound))/ 100)
        // this.percentageArea = (100 - ((calculateArea(this.wound?.child_wounds[0]) - calculateArea(this.actualParentWound))/ 100));
        // this.actualVolume = ((calculateVolume(this.wound?.child_wounds[0]) - calculateVolume(this.actualParentWound))/ 100);
        // this.percentageVolume = (100 - ((calculateVolume(this.wound?.child_wounds[0]) - calculateVolume(this.actualParentWound))/ 100));
      } else {
        this.percentageArea = ((calculateArea(this.wound?.child_wounds[0]) - calculateArea(this.wound?.child_wounds[this.wound?.child_wounds?.length - 1]))/calculateArea(this.wound?.child_wounds[this.wound?.child_wounds?.length - 1]))*100;
        this.percentageVolume = ((calculateVolume(this.wound?.child_wounds[0]) - calculateVolume(this.wound?.child_wounds[this.wound?.child_wounds?.length - 1]))/calculateVolume(this.wound?.child_wounds[this.wound?.child_wounds?.length - 1]))*100;
      }
      if (Number.isNaN(this.percentageArea) || !Number.isFinite(this.percentageArea)) {
        // this.actualArea = 0;
        this.percentageArea = 0;
      }
      if (Number.isNaN(this.percentageVolume) || !Number.isFinite(this.percentageVolume)) {
        this.actualVolume = 0;
        this.percentageVolume = 0;
      }
      this.percentageArea = Math.round(this.percentageArea);
      if (this.percentageVolume < 0) {
        this.actualVolume = this.percentageVolume;
        this.percentageVolume = Math.round(Math.abs(this.percentageVolume));
      } else {
        this.actualVolume = this.percentageVolume;
        this.percentageVolume = Math.round(this.percentageVolume);
      }
    } else {
      this.actualArea = 0;
      this.actualVolume = 0;
      this.percentageArea = 0;
      this.percentageVolume = 0;
    }
    this.loader.stopLoader(this.childWoundsLoaderId);
  }
  getFormattedDate(date) {
    if(!date) return '';
    let date1: any = date.toString();
    if (date1.includes('Z')) {
      let date2 = date1.split('T');
      let date3 = date2[0].split('-');
      return date3[1] + '/' + date3[2] + '/' + date3[0];
    }
    else {
      if(date?._i){
        let day = (date._i.date < 10) ? ('0' + (date._i.date).toString()) : (date._i.date).toString();
        let month = (date._i.month + 1  < 10) ? ('0' + (date._i.month + 1).toString()) : (date._i.month + 1).toString();
        let year = (date._i.year);
        return month + "/" + day + "/" + year;
      }else{
        let timeZone = "America/New_York";
        if(this.note.facility && this.note.facility.timeZone){
          timeZone = this.note.facility.timeZone;
        }
        return moment(date).tz(timeZone).format('MM/DD/YYYY')
      }
    }
  }



  handleWoundClick($event, latest_child_wound) {
    console.log('handleWoundClick')
    if (!this.isClickAllowed($event.target)) return;
    this.showWoundCreateDialog(latest_child_wound);
  }
  toggleExpand() {
    this.expanded = !this.expanded
  }
  expand() {
    this.expanded = true;
  }
  collapse($event) {
    if (!this.isClickAllowed($event.target)) return;

    this.expanded = false;
    this.expandedView = '';
  }
  handleMainItemClick($event) {
    if (!this.isClickAllowed($event.target)) return;
    if (!this.expandedView) return;
    this.toggleExpand();
  }
  toggleChildWounds() {
    if (this.expandedView === 'child_wounds') {
      this.toggleExpand();
    } else {
      this.expand();
      this.expandedView = 'child_wounds';
      this.initChildWounds();
    }
  }
  handleGraphClick() {
    if (this.expandedView === 'graph') {
      this.toggleExpand();
    } else {
      this.expand();
      this.expandedView = 'graph';
    }
  }

  toggleShowAllImages() {
    if (this.expandedView === 'wound_images') {
      this.toggleExpand();
    } else {
      this.expand();
      this.expandedView = 'wound_images';
    }
    // this.showAllImages = !this.showAllImages
  }
  calculateTimeDifference(wound) {
    return calculateTimeDifference(wound, this.actualParentWound);
  }
  calculateArea(wound) {
    return calculateAreaforBanner(wound);
  }
  calculateVolume(wound) {
    return calculateVolumeforBanner(wound);
  }

  async showWoundCreateDialog(childWound) {
    console.log("this.childWound", childWound, this.actualParentWound);
    const dialogRef = this.dialog.open(CreateWoundDialogComponent, {
      maxHeight: '90vh',
      maxWidth: '100vw',
      width: '98%',
      height: '90%',
      data: {
        provider: this.provider,
        patient: this.patient,
        wound: this.actualParentWound,
        childWound,
        onICDsSave: this.onICDsSave
      }
    });
    dialogRef.afterClosed().subscribe(async (data) => {
      if (data) {
        this.actualParentWound = data.wound;
        if (this.actualParentWound?.latest_child_wound && this.actualParentWound?.latest_child_wound.findIndex((wound) => wound._id === data.childWound._id) > -1) {
          let index = this.actualParentWound.child_wounds.findIndex((wound) => wound._id === data.childWound._id);
          if (index > -1 && data.stage != "") {
            this.actualParentWound.child_wounds[index].stage = data.stage
          }
        }
        if (data.wound.state != data.state) {
          this.changeWoundState.emit(data.wound);
          this.woundCareWidgetService.setState(true);
        }
      }
      if(data.updateData){
        this.woundDetailsChange.emit(data.updateData)
      }
    });
  }
  showWoundImagePreviewDialog(wound, imageIndex = 0) {
    const dialogRef = this.dialog.open(WoundImagePreviewDialogComponent, {
      width: 'auto',
      data: { wound: wound, imageIndex: imageIndex }
    });
  }
  deleteWoundImage(wound, imageIndex) {
    let imageList = this.otherImages[imageIndex].split("?")[0].split('/');
    let imageName = imageList[imageList.length - 1];
    let dialogRef = this.dialog.open(DialogConfirmationComponent, {
      data: {
        message: 'Are you sure you want to delete image?'
      }
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === "true") {
        this.woundCareWidgetService.deleteWoundOtherImages(wound._id, [imageName]).toPromise().then((res: any) => {
          if (res.status == 200) {
            this._toaster.success("Image Deleted Successfully", "Success");
            this.wound.wound_images.splice(this.wound.wound_images.indexOf(this.otherImages[imageIndex]), 1);
            this.otherImages.splice(imageIndex, 1);
          }
        });
      }
    });
  }

  async handleChangeWoundState(value) {
    const { status, data } = await lastValueFrom(this.woundCareWidgetService.updateWoundData(this.actualParentWound._id, { state: value }))
    if (status == 200) {
      console.log(data);
    }
  }

  showEdit() {
    return !(this.actualParentWound.body_side &&
      this.actualParentWound.body_part &&
      this.actualParentWound.wound_type &&
      this.actualParentWound.stage)
  }

  hasChildWounds() {
    return this.wound?.child_wounds?.length > 0
    // return this.wound.latest_child_wound.length
    // return this.wound !== this.actualParentWound;
  }

  showWoundImageUploadDialog() {
    const dialogRef = this.dialog.open(WoundImageUploadDialogComponent, {
      width: 'auto',
      data: { wound: this.wound }
    });
    dialogRef.afterClosed().subscribe(async (uploadedImages: string[]) => {
      if (Array.isArray(uploadedImages)) {
        this.wound.wound_images = this.wound.wound_images.concat(uploadedImages);
        this.otherImages = this.otherImages.concat(uploadedImages);
      }
    });
  }
  showWoundImageSnapshotDialog() {
    const dialogRef = this.dialog.open(WoundImageSnapshotDialogComponent, {
      width: 'auto',
      data: { wound: this.wound }
    });
    dialogRef.afterClosed().subscribe(async (uploadedImages: string[]) => {
      if (Array.isArray(uploadedImages)) {
        this.otherImages = this.otherImages.concat(uploadedImages);
        this.wound.wound_images = this.wound.wound_images.concat(uploadedImages);
      }
    });
  }

  showWoundNoteDialog() {
    const dialogRef = this.dialog.open(WoundNoteDialogComponent, {
      width: 'auto',
      data: { wound: this.wound }
    });
    dialogRef.afterClosed().subscribe(async (data) => {
      if (typeof data === 'string') {
        this.wound.extra_note = data;
      }
    });
  }
  isArchivedWound() {
    return this.actualParentWound.state === 'archived'
  }

  isClickAllowed($element) {
    const { classList, tagName } = $element;
    console.log({ classList, tagName, $element })
    const tagNames = ['button', 'mat-icon'];
    const classNames = ['mat-button-wrapper'];
    if (tagNames.includes(tagName.toLowerCase())) return false;
    if (classNames.some(className => classList.contains(className))) return false;
    return true;

  }
  showSetStageDialog(wound) {
    const dialogRef = this.dialog.open(SetWoundStageDialogComponent, {
      width: 'auto',
      data: { wound: wound, patient: this.patient, provider: this.provider }
    });
    dialogRef.afterClosed().subscribe(async (data) => {
      if (data) {
        // this.wound = Object.assign(this.wound, data);
        for (const key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key)) {
            const value = data[key];
            this.wound[key] = value;
          }
        }
      }
    });
  }
  isWoundInDateRange(wound) {
    const weeks = parseInt(this.last_n_weeks);
    if (isNaN(weeks)) return true;
    const dateNWeek = moment().subtract(weeks, 'weeks');
    return moment(wound.createdAt).isAfter(dateNWeek);
  }
  WoundStatechange(data: any) {
    this.changeWoundState.emit(this.actualParentWound);
  }

  showWoundReport(wound, isDownload) {
    this.woundAnalyticReport.emit(wound);
  }
}
